import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "../../config/config";
import { map } from 'rxjs/operators';
import { apiConstants } from "../constant/apiConstant";
@Injectable()
export class ClassManageService {

  private _url = AppSettings.API_ENDPOINT;
  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  private getClassListWithAttendanceType = apiConstants.getClassListWithAttendanceType;
  private changeAttendanceTypeForParticularClass = apiConstants.changeAttendanceTypeForParticularClass;
  private changeAttendanceTypeForAllClass = apiConstants.changeAttendanceTypeForAllClass;
  private updateStaffFeesAccess = apiConstants.updateStaffFeesAccess;
  headers: HttpHeaders;

  constructor(private http: HttpClient) {
    const token = localStorage.getItem('usertoken');
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "authToken": token,
      'token': token
    })
  }

  schoolClassManagementGetCategoryList(getSchoolId, academicId, AUTHTOKEN) {
    const params = { getSchoolId: getSchoolId, academicId: academicId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/categorylist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  schoolClassManagementGetClassList(getSchoolId, academicId, AUTHTOKEN) {
    const params = { getSchoolId: getSchoolId, academicId: academicId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/classlist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //list all subjects
  schoolClassManagementGetSubjectList(getSchoolId, AUTHTOKEN) {
    const params = { getSchoolId: getSchoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/subjectlist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //list all subjects [view]
  schoolClassManagementGetSubjectListView(subjectId, AUTHTOKEN) {
    const params = { subjectId: subjectId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/subjectlist/view',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getStudentListClassSection(schoolId, academicId, classId, AUTHTOKEN) {
    const params = { schoolId: schoolId, academicId: academicId, classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentlistclassection',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getCategoryListService(schoolId, AUTHTOKEN) {
    const params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/manageClass/categoryList',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getCategoryClassListService(schoolId, academicId, categoryId, AUTHTOKEN) {
    const params = { schoolId: schoolId, academicId: academicId, categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/manageClass/classStandardListByCategory',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //add new category
  addCategoryNewCategoryService(categoryName, schoolId, AUTHTOKEN) {
    const params = { categoryName: categoryName, schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/manageClass/categoryAddNew',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //add new category
  updateCategoryListCategoryService(categoryNewName, schoolId, categoryId, AUTHTOKEN) {
    const params = { categoryNewName: categoryNewName, schoolId: schoolId, categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/manageClass/categoryUpdateName',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  //update class name
  updateClassNameService(standardId, standard, AUTHTOKEN) {
    const params = { classStandardsId: standardId, classStandard: standard };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/className/updateclassname',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  //list class classes
  getClassListService(schoolId, academicId, AUTHTOKEN) {
    const params = { schoolId: schoolId, academicId: academicId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/manageClass/classList',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassSectionListService(schoolId, standardId, AUTHTOKEN) {
    const params = { schoolId: schoolId, classId: standardId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classSectionName',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassViewaddNewClassSections(schoolId, NewClassName, SectionName, categoryId, AUTHTOKEN) {
    const params = { schoolId: schoolId, className: NewClassName, section: SectionName, categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement_addStandard',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  //list all subjects
  getSubjectList(schoolId, AUTHTOKEN) {
    const params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/manageClass/subjectList',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  updateSubject(subId, subName, AUTHTOKEN) {
    const params = { subjectId: subId, subjectName: subName };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement_standard_UpdateSubject',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  listClassCategory(schoolId, AUTHTOKEN) {
    const params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/category',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  listClassCategoryDetailList(schoolId, categoryId, AUTHTOKEN) {
    const params = { schoolId: schoolId, categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/categorydetailslist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //add new category
  addNewCategoryService(schoolId, categoryName, AUTHTOKEN) {
    const params = { schoolId: schoolId, catName: categoryName };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/category/categoryaddnewcategory',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  listClassSection(schoolId, AUTHTOKEN) {
    const params = { schoolId: schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/listStandards',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //add new category
  addNewClassSections(schoolId, NewClassName, SectionName, categoryId, AUTHTOKEN) {
    const params = { schoolId: schoolId, className: NewClassName, section: SectionName, categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement_addStandard',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //list class section in standard view
  viewStandardListSection(classId, AUTHTOKEN) {
    const params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classSectionName',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  //delete section from std view
  deleteSectionInStdView(secid, AUTHTOKEN) {
    const params = { classId: secid };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement_standard_DeleteSection',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  //Update section from std view
  UpdateSectionInStdView(stdId, secid, section, categoryId, AUTHTOKEN) {
    const params = { classStandardId: stdId, classId: secid, section: section, categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement_standard_UpdateSection',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  fetchSubjectListandStaff(classId, AUTHTOKEN) {
    const params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/subject/class/subjectswithstaff',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getSubjectsNotInClass(classId, AUTHTOKEN) {
    const params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/subject/class/subjectnotinclass',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //list class standards
  viewStandardListStudent(schoolId, academicId, categoryId, classId, sectionId, countFrom, lengthOf, AUTHTOKEN) {
    const params = { schoolId: schoolId, academicId: academicId, categoryId: categoryId, classId: classId, sectionId: sectionId, countFrom: countFrom, lengthOf: lengthOf };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  assignSubjectToClass(classId, subjectId, AUTHTOKEN) {
    const params = { classId: classId, subjectId: subjectId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/subject/class/add',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  unAssignSubjectTostaff(classId, staffId, subjectId, AUTHTOKEN) {
    const params = { classId: classId, staffId: staffId, subjectId: subjectId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/subject/class/unassignsubjecttostaff',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  addSubject(subjectName, AUTHTOKEN) {
    const params = { subjectname: subjectName };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/class_management/subjects/addnewsubject',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  removeSubjectfromClass(classId, subjectId, AUTHTOKEN) {
    const params = { classId: classId, subjectId: subjectId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/subject/class/remove',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  searchStaff(searchData, AUTHTOKEN) {
    const params = { searchData: searchData };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/searchStaffWithName',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  searchClassTeacher(searchData, AUTHTOKEN) {
    const params = { searchData: searchData };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/stafflist/getStaffWithClassTeacherPermission',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  assignSubjectTostaff(staffId, classId, subjectId, AUTHTOKEN) {
    const params = { staffId: staffId, classId: classId, subjectId: subjectId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/subject/class/assignsubjecttostaff',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  fetchClassTeacher(classId, AUTHTOKEN) {
    const params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement/getClassTeacher',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  addClassTeacher(classId, staffId, staffPosition, AUTHTOKEN, isStaffHasPermissionToViewStudentFees) {
    const params = { classId: classId, staffId: staffId, staffPosition: staffPosition, isStaffHasPermissionToViewStudentFees};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement/assignClassTeacher',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  removeteacher(classId, staffId, staffPosition, AUTHTOKEN) {
    const params = { classId: classId, staffId: staffId, staffPosition: staffPosition };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classManagement/classmanagement/removeClassTeacher',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  updateClassOrder(classStandardId, AUTHTOKEN) {
    const params = { classStdList: classStandardId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/classlist/updateClassListSequence',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  updateClassSectionOrder(classId, AUTHTOKEN) {
    const params = { sectionList: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/updateClassSectionSequence',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  sectionDetail(classId, AUTHTOKEN) {
    const params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classSectionName/sectionDetail',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  configTimeTable(config, AUTHTOKEN) {
    const params = config;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/updateorcreatetimetableconfig',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  getTimeTable(categoryId, AUTHTOKEN) {
    const params = { categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/gettimetableconfig',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassesOfCategory(categoryId, AUTHTOKEN) {
    const params = { categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/getclassesofcategory',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  fetchSubjectOfClass(classId, AUTHTOKEN) {
    const params = { classId: classId, getStaff: 'yes' };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/getsubjectsofclass',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  fetchTimeTableOfClass(classId, AUTHTOKEN) {
    const params = { classId: classId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/gettimetableofclass',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  updateTimeTable(dataToSend, AUTHTOKEN) {
    const params = dataToSend;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/addtimetable',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  getStaffScheduledByTime(reqObj, AUTHTOKEN) {
    const params = reqObj;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/getstaffschedulebytime',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  reomoveTimeSlotForStaff(scheduleId, AUTHTOKEN) {
    const params = { scheduleId: scheduleId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/timetable/removeTimeSlotInClassTimetable',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  studentSubjectAssignListService(classId, subjectId, AUTHTOKEN) {
    const params = { classId: classId, subjectId: subjectId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/exam/studentSubjectAssignList',
      params, { headers: headers })
      .pipe(map(res => res));
  }
  addOrRemoveStudentFromSubjectService(studentData, AUTHTOKEN) {
    const params = studentData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/exam/addOrRemoveStudentFromSubject',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassListWithAttendanceTypeApi() {
    return this.http.get(this.URL_V3 + `${this.getClassListWithAttendanceType}/?lang=en`, { headers: this.headers }).pipe(map(res => res));
  }

  changeAttendanceTypeForParticularClassApi(body: any) {
    return this.http.put(this.URL_V3 + `${this.changeAttendanceTypeForParticularClass}`, body, { headers: this.headers }).pipe(map(res => res));
  }

  changeAttendanceTypeForAllClassApi(body: any) {
    return this.http.put(this.URL_V3 + `${this.changeAttendanceTypeForAllClass}`, body, { headers: this.headers }).pipe(map(res => res));
  }

  staffPermissionForFeeAccess(body: any) {
     return this.http.put(this.URL_V3 + `${this.updateStaffFeesAccess}`, body, { headers: this.headers }).pipe(map(res => res));
  }

}